import { Link } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import SignOutModal from '../sign-out-modal/SignOutModal';
import NotificationBanner from '../notificationBanner/NotificationBanner';
import { CartSVG } from '../svgs';
import { PermissionService } from '../../services/permission.service';
import { AccountRoles, AppRoles } from '../../types/enums';
import { APP_PATHS } from '../../constants/routePaths';
import { NOTIFICATION_CONSTANTS, RSG_CONSTANTS } from '../../constants/common';

const TitleBar = ({ showSignOut = false }: { showSignOut: boolean }): JSX.Element => {
  const accountRoles = useAppSelector(state => state.auth.accountContext.roles) as AccountRoles[];
  const appRoles = useAppSelector(state => state.auth.appContext.roles) as AppRoles[];
  const cartItems = useAppSelector(state => state.transactionCart.transactionCartItems);
  const enabled = useAppSelector(state => state.user.enabled);
  const verified = useAppSelector(state => state.user.verified);
  const activeAccount = useAppSelector(state => state.activeAccount);

  const permissionService = new PermissionService(accountRoles, appRoles, enabled, verified);

  return (
    <div className="title-bar">
      <div className="logo">{RSG_CONSTANTS.RSG_TITLE}</div>
      {showSignOut ? (
        <div className="sign-out-link">
          <SignOutModal />
        </div>
      ) : (
        <div className="notification-cart-container">
          {activeAccount?.locked && (
            <NotificationBanner
              children={
                <div className="payment-details-not-found-notification">
                  <p>{NOTIFICATION_CONSTANTS.ACCOUNT_LOCKED}</p>
                </div>
              }
            />
          )}
          {(permissionService.userHasRSGAdminPermission() || permissionService.userHasInventoryPermission()) && (
            <Link className="button icon" to={APP_PATHS.TRANSACTION_CART}>
              <CartSVG />
              {cartItems.length > 0 && <span className="cart-item" />}
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default TitleBar;
